/**
 * GTM Front Handlers - Footer Script
 *
 * Button and menu click handlers for GTM tracking.
 * This script should be loaded in the footer.
 */

import './button-handlers';
import './menu-handler';
